import { nameInitials } from '../../lib/utils';
import { cn } from '../../lib/utils';

interface AvatarProps {
  name?: string;
  initials?: string;
  size?: number;
  className?: string;
}

export function Avatar({ name, initials, size = 26, className }: AvatarProps) {
  const text = initials ?? (name ? nameInitials(name) : '?');
  return (
    <span
      className={cn('av', className)}
      style={{ width: size, height: size, fontSize: Math.max(9, size * 0.4) }}
      title={name}
    >
      {text}
    </span>
  );
}
